import { createContext, useState } from "react";
import { ContextProviderProps } from "../../../types";
import { ExciseStampsState, UpdateStampsFunction } from "./exciseStamps.types";

export const initialState = (): ExciseStampsState => {
  return {
    //Response for inicijalniPodaciZaZahtevObveznika

    kategorijaProizvoda: [],
    vrstaProizvoda: [],

    //Response for vracanjeDodatnihInformacijaZaKreiranjeZahteva

    drustvoInformationMarkiceZahtev: {
      id: null,
      naziv: "",
      imeGrada: "",
      adresa: "",
      pib: "",
      maticniBroj: "",
      imeIPrezimeKontaktOsobe: "",
      emailAdresaKontaktOsobe: "",
      jmbgKontaktOsoba: "",
      brojTekucegRacuna: [],
      preteznaDelatnost: "",
      emailAdresa: "",
      postanskiBroj: "",
      imeDrzave: "",
      ovlascenaLicaZaPreuzimanjeMarkica: [],
    },
    isUvoznik: false,
    kategorijeZaZahtev: {
      kategorijaZaZahtev: [],
      pakovanjaZaZahtev: [],
      tipPakovanja: [],
      tipPakovanjaShow: false,
    },
    prikaziMaloprodajneCene: true,
    isPP: false,

    //Response for kreiranjeZahtevaZaMarkicu

    zahtevMarkicaId: null,

    //Payload for kreiranjeZahtevaZaMarkicu

    kategorijaProizvodaId: 0,
    tipObveznikaIds: [],
    inostraniProizvodjac: {
      naziv: "",
      poreskiBroj: "",
      adresa: "",
      mesto: "",
    },
    distributer: {
      naziv: "",
      poreskiBroj: "",
      adresa: "",
      mesto: "",
    },
    adresaSlanjaMarkica: "",
    podaciOTrazenimMarkicama: [],
    dokumentSpecifikacija: null,

    //Response for informacijeNapravljenogZahtevaZaMarkicu
    dokumentSpecifikacijaDetails: null,
    brojPorudzbenice: "",
    markicaZahteviDrustvoInfoDto: {
      naziv: "",
      imeGrada: "",
      adresa: "",
      pib: "",
      maticniBroj: "",
      brojTekucegRacuna: [],
      preteznaDelatnost: "",
      ovlascenaLicaZaPreuzimanjeMarkica: [],
    },
    kategorijaVrstaZahtevaDto: [],
    imaPakovanje: false,
    showNedostajuceVrednosti: false,
    statusZahteva: "",
    stampajPredracun: false,
    isVracenNaDopunu: false,
    markicaZahtevStatusNotes: [],
    zahtevZaMarkicuUvoznik: {
      inostraniProizvodjacNaziv: "",
      inostraniProizvodjacPoreskiBroj: "",
      inostraniProizvodjacAdresa: "",
      inostraniProizvodjacMesto: "",
      distributerInostranogProizvodjacaNaziv: "",
      distributerInostranogProizvodjacaPoreskiBroj: "",
      distributerInostranogProizvodjacaAdresa: "",
      distributeraInostranogProizvodjacaMesto: "",
      distributerInostranogProizvodjacaAdresaSlanjaMarkica: "",
    },
    markicaZahtevStatusi: {
      odobren: null,
      odbijen: null,
      vracenNaDopunu: null,
    },

    //Response for podaciOMarkamaProizvoda

    podaciOMarkamaProizvoda: [],

    //Response for maloprodajneCeneMarkiProizvoda

    maloprodajneCeneMarkiProizvoda: [],

    //SelectedStamps

    podaciOTrazenimMarkicamaPrint: [],
    selectedVrstaAkcizneMarkiceIme: "",
    selectedOznakaPakovanjaOpis: "",
    selectedVrstaAkcizneMarkiceId: null,
    selectedOznakaPakovanjaId: null,
    selectedTrazeneKolicine: "",
    selectedMarkicaId: null,
    isporuceniOpsezi: [],
    selectedNedostajuceVrednosti: "",
    tipPakovanjaId: null,
    tipPakovanja: "",
    tipPakovanjaShow: false,
    evidencioniBroj: "",
    isOpseg: false,
    isDistributerRequired: false,
    isProizvodjacRequired: false,
    datumIsporuke: null,
  };
};

interface IExciseStampsContext {
  exciseStamps: ExciseStampsState;
  setExciseStamps: UpdateStampsFunction;
  clearStampsState: () => void;
  clearOpseg: () => void;
  clearPayloadState: () => void;
}

export const ExciseStampsContext = createContext<IExciseStampsContext>(
  null as any
);

export const ExciseStampsContextProvider = ({
  children,
}: ContextProviderProps) => {
  const [exciseStamps, setExciseStampsState] = useState(initialState());

  const handleSetStamps = (updatedState: Partial<ExciseStampsState>) => {
    setExciseStampsState((prev) => ({ ...prev, ...updatedState }));
  };

  const setExciseStamps = (updatedState: Partial<ExciseStampsState>) => {
    handleSetStamps({ ...updatedState });
  };

  const clearStampsState = () => {
    setExciseStampsState(initialState());
  };

  const clearOpseg = () => {
    const updatedState: Partial<ExciseStampsState> = {
      isOpseg: false,
    };

    setExciseStamps(updatedState);
  };

  const clearPayloadState = () => {
    const updatedState: Partial<ExciseStampsState> = {
      inostraniProizvodjac: {
        naziv: "",
        poreskiBroj: "",
        adresa: "",
        mesto: "",
      },
      distributer: {
        naziv: "",
        poreskiBroj: "",
        adresa: "",
        mesto: "",
      },
      adresaSlanjaMarkica: "",
      podaciOTrazenimMarkicama: [],
      podaciOTrazenimMarkicamaPrint: [],
      selectedVrstaAkcizneMarkiceId: null,
      selectedOznakaPakovanjaId: null,
      selectedTrazeneKolicine: "",
      tipPakovanjaId: null,
      tipPakovanja: "",
      kategorijaProizvodaId: null,
      tipObveznikaIds: [],
      dokumentSpecifikacija: null,
    };
    setExciseStamps(updatedState);
  };

  return (
    <ExciseStampsContext.Provider
      value={{
        exciseStamps,
        setExciseStamps,
        clearStampsState,
        clearPayloadState,
        clearOpseg,
      }}
    >
      {children}
    </ExciseStampsContext.Provider>
  );
};
